import type { Stripe, StripeError } from '@stripe/stripe-js';

export async function confirmStripeCardPayment(
	stripe: Stripe,
	paymentMethod: string | undefined,
	clientSecret: string,
): Promise<StripeError | undefined> {
	const { error } = await stripe.confirmCardPayment(clientSecret, {
		payment_method: paymentMethod,
	});

	return error;
}
